module.exports = __webpack_public_path__ + "img/clogo.c66373c4.png";